module.exports = __webpack_public_path__ + "static/media/item_sli_boost_des.c150af3a.png";